import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BackButtonComponent } from '../back-button/back-button.component';
import { VerifiedHeaderComponent } from 'src/app/pages/verified/verified-header/verified-header.component';
import { StarterHeaderComponent } from 'src/app/pages/starter/starter-header/starter-header.component';
import { StarterHeaderTsComponent } from 'src/app/pages/starter/starter-header-th/starter-header-th.component';
import { VerifiedHeaderComponentTh } from "src/app/pages/verified/verified-header-th/verified-header-th.component";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    BackButtonComponent,
    VerifiedHeaderComponent,
    StarterHeaderComponent,
    StarterHeaderTsComponent,
    VerifiedHeaderComponentTh
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  currentUrl: string = '';
  currentIndex: number = 0;
  onboardingType: string = '';

  constructor(private router: Router) {
    // Subscribe to router events to update the current URL
    this.router.events.subscribe(() => {
      this.currentUrl = this.router.url;
      this.currentIndex = Number(localStorage.getItem('checkPointIndex')?.split('_')[0]) || 0; // Get the index from the checkpoint index

      console.log("currentIndex", this.currentIndex);
      this.onboardingType = localStorage.getItem('onboardingType') || '';
    });
  }
}
